import { LAYOUTS } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import SharedPropsService from '../../../SharedPropsService';
import { ACTION } from './types';
import { GoBackAction, NavigateNext, ToggleKYCSummaryCTA, ToggleKYCSummaryCTA_Action, verifyKycSummary, updateKyc, needHelpAction, onLoadAction } from './actions';
import { convertDateString, getContactUsDetails, getDateMonthYearFromEpoch, horizontalStepperRepo } from '../../../configs/utils';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import _ from 'lodash';
import { show2ndCheckBox } from "./utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const template = (pan, address, dob, fullName, photoURL, stepper, lenderId, height, showSecondTC, showKYCEdit, isFromJupiter, actualKYCDate, contactUsDetails) => ({
    layout: {
        id: ROUTE.KYC_SUMMARY,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "kycSummaryPage", type: WIDGET.KYC_SUMMARY }
        ],
    },
    datastore: {
        kycSummaryPage: {
            height: height,
            stepperData: stepper,
            lenderId: lenderId,
            showSecondTC: showSecondTC,
            fullName: fullName,
            dob: actualKYCDate,
            address: address,
            radioButtonCheck1: {
                type: ACTION.T_AND_C_CHECK_1,
                routeId: ROUTE.KYC_SUMMARY,
                payload: {}
            },
            radioButtonCheck2: {
                type: ACTION.T_AND_C_CHECK_2,
                routeId: ROUTE.KYC_SUMMARY,
                payload: {}
            },
            continueToNextStep: {
                type: ACTION.NAV_TO_BANK_ADD,
                routeId: ROUTE.KYC_SUMMARY,
                payload: {}
            },
            radioButton1Check: true,
            radioButton2Check: true,
            showSuccess: false,
            navigateToNextStep: {
                type: ACTION.NAVIGATION_NEXT,
                routeId: ROUTE.KYC_SUMMARY,
                payload: {}
            },
            loading: false,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.KYC_SUMMARY,
                payload: {},
            },
            updateKycAction: {
                type: ACTION.UPDATE_KYC,
                routeId: ROUTE.KYC_SUMMARY,
                payload: {},
            },
            showKYCEdit: showKYCEdit,
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.KYC_SUMMARY,
                payload: {},
            },
            isFromJupiter: isFromJupiter,
            contactUsDetails,
        },
    },
});
export const kycSummaryMf = {
    onLoad: async ({ network, getHeight }) => {
        const user = await SharedPropsService.getUser();
        const contactUsDetails = await getContactUsDetails();
        let applicationId = '';
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = user.linkedApplications[0].applicationId;
        }
        const pan = user.linkedBorrowerAccounts[0].accountHolderPAN;
        const response = await network.get(`${api.kycSummaryInit}${applicationId}`, { headers: await getAppHeader() });
        const lenderId = response?.data?.updatedApplicationObj?.lenderAccountId;
        const showSecondTC = show2ndCheckBox(lenderId);
        const address = _.get(response, 'data.stepResponseObject.address');
        const dob = _.get(response, 'data.stepResponseObject.dob');
        const fullName = _.get(response, 'data.stepResponseObject.fullName');
        const photoURL = _.get(response, 'data.stepResponseObject.photoURL');
        const stepper = await horizontalStepperRepo(network);
        const showKYCResponse = await network.get(`${api.showKYCEdit}${applicationId}`, { headers: await getAppHeader() });
        const showKYCEdit = showKYCResponse?.data?.isEnabled;
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER";
        const readableDob = getDateMonthYearFromEpoch(Number(dob));
        const actualKYCDate = convertDateString(readableDob);
        return Promise.resolve(template(pan, address, dob, fullName, photoURL, stepper, lenderId, getHeight(), showSecondTC, showKYCEdit, isFromJupiter, actualKYCDate, contactUsDetails));
    },
    actions: {
        [ACTION.NAV_TO_BANK_ADD]: verifyKycSummary,
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.TOGGLE_CTA]: ToggleKYCSummaryCTA,
        [ACTION.NAVIGATION_NEXT]: NavigateNext,
        [ACTION.T_AND_C_CHECK_1]: ToggleKYCSummaryCTA_Action,
        [ACTION.T_AND_C_CHECK_2]: ToggleKYCSummaryCTA_Action,
        [ACTION.NEED_HELP]: needHelpAction,
        [ACTION.UPDATE_KYC]: updateKyc,
        [ACTION.ON_LOAD]: onLoadAction,
    },
    action: {
        type: ACTION.ON_LOAD,
        routeId: ROUTE.KYC_SUMMARY,
        payload: {}
    }
};
